import {
  getMinWidth,
  getMinHeight,
} from '@wix/search-box-v2/dist/src/components/SearchBox/measure';

export function measureComponent(
  node,
  {text, sizes, shouldDecreaseHeight, shouldDecreaseWidth, isCollapsed},
) {
  if (!node) {
    return null;
  }
  const root = node.querySelector('form[data-hook="search-box-form"]');

  const minHeight = getMinHeight(root);
  const minWidth = isCollapsed ? minHeight : getMinWidth(root, {text});

  let width = Math.max(minWidth, root.offsetWidth);
  let height = Math.max(minHeight, root.offsetHeight);

  if (sizes) {
    // Handle component size change due to settings update
    if (shouldDecreaseWidth && sizes.width === sizes.minWidth && width === sizes.width) {
      width = minWidth;
    }
    if (shouldDecreaseHeight && sizes.height === sizes.minHeight && height === sizes.height) {
      height = minHeight;
    }
  }

  if (isCollapsed) {
    // Maintain 1x1 proportions TODO: SER-305 remove this workaround once it's supported by editor
    if (sizes && sizes.minWidth !== minWidth) { // Switched to expandable
      width = height;
    } else {
      width = height = Math.max(width, height);
    }
  }

  return {minHeight, minWidth, height, width};
}
